import { useEffect, useState } from 'react';

const hasDarkClass = () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark');

export function useDocumentDarkClass() {
  const [isDark, setIsDark] = useState(hasDarkClass);

  useEffect(() => {
    const observer = new MutationObserver(() => setIsDark(hasDarkClass()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    setIsDark(hasDarkClass());
    return () => observer.disconnect();
  }, []);

  return isDark;
}
